import { useEffect, useState } from 'react';
import { HardDrive } from 'lucide-react';
import { api } from '../api';
import { tamano } from './formato';

/** «X de Y GB» de Archivos, para Ajustes → Suscripción (Parte F). */
export default function BarraDeCuota() {
  const [c, setC] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/archivos/cuota').then((r) => { if (vivo) setC(r); }, () => { if (vivo) setC(null); });
    return () => { vivo = false; };
  }, []);
  if (!c) return null;
  const tono = c.lleno ? 'bg-red-600' : c.aviso ? 'bg-amber-500' : 'bg-[var(--color-marca)]';
  return (
    <div className="space-y-1" data-cuota-archivos>
      <div className="flex items-center gap-2 text-sm text-gray-800">
        <HardDrive className="h-4 w-4 text-[var(--color-marca)]" aria-hidden="true" />
        <span>Archivos: {tamano(c.usados_bytes)} de {c.tope_gb} GB</span>
        <span className="ml-auto text-xs text-gray-500">{c.origen === 'PLAN' ? 'del plan' : 'de este servidor'}</span>
      </div>
      <div className="h-1.5 bg-gray-200 rounded" role="progressbar" aria-valuenow={c.por_ciento} aria-valuemin="0" aria-valuemax="100" aria-label="Espacio de archivos usado">
        <div className={`h-1.5 rounded ${tono}`} style={{ width: `${Math.min(100, c.por_ciento)}%` }} />
      </div>
      {c.aviso && <p className="text-xs text-amber-800">Queda poco espacio para archivos. Pide más almacenamiento abajo, en «Pedir más recursos».</p>}
    </div>
  );
}
